<template>
    <div class="pafcpic_navbar flex flex-row justify-end w-full">
        <div class="">
        </div>
        <div class="flex items-center relative gap-11">
            <div class="flex gap-5 items-center">
                <div v-if="notificationButton" class="fixed top-0 left-0 w-[100vw] h-[100vh] z-10 blur-lg "  @click="$emit('notificationButtonClose')">
                </div>  
                <div class="bg-[#ffffff]  p-2 rounded-full border shadow w-full" @click="$emit('notificationButton')"> 
                    <Notification/>
                    <div v-if="notificationButton" class="px-5   absolute top-[60px]  left-[-20px] w-full bg-[#DCDDDC] rounded-sm z-10">
                        <div class="flex flex-col absolute top-0 bg-[#e0e0e0] w-[300px] z-10">
                            <div class=" px-7 flex flex-col py-2 hover:bg-[#CCAF12] border-b-[#bebebe] border">
                                <p class="text-sm text-[#838383]  text-center">No Notification Found</p>
                            </div>
                            <!-- <div class=" px-7 flex flex-col py-2 hover:bg-[#CCAF12] border-b-[#bebebe] border">
                                <p class="text-md text-[#12760A] font-semibold">A Leave Application Approved!</p>
                                <p class="text-sm text-[#838383] ">A Leave Application Approved!..</p>
                                <p class="text-xs text-[#838383] mt-1">03-06-2024 09:18</p>
                            </div>
                            <div class=" px-7 flex flex-col py-2 hover:bg-[#CCAF12] border-b-[#bebebe] border">
                                <p class="text-md text-[#12760A] font-semibold">A Leave Application Approved!</p>
                                <p class="text-sm text-[#838383] ">A Leave Application Approved!..</p>
                                <p class="text-xs text-[#838383] mt-1">03-06-2024 09:18</p>
                            </div> -->
                            <div class=" py-3">
                                <p class="text-sm text-[#12760A] font-semibold text-center hover:text-[#CCAF12]">Show all notification</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="bg-[#ffffff] p-2 rounded-full  border shadow">
                    <router-link to="/message">
                    <Message />       
                </router-link>
                </div> -->
            </div>
            <div class=" bg-[#ffffff]flex mr-9 items-center w-full">
                <div v-if="accountButton"  @click="$emit('accountButtonClose')" class="fixed top-0 left-0 w-[100vw] h-[100vh] bg-[#837f7f1e] -z-0">
                </div>
                <div class="w-full" @click="$emit('accountButton')">
                    <div class="relative w-full  grow-0 flex items-center bg-[#DCDDDC] rounded-full shadow-[30px] hover:bg-[#CCAF12]">
                    <div class="bg-[#ffffff] p-2 rounded-full shadow">
                        <Avatar/> 
                    </div>
                    <div  class="grow text-[#016B00] font-bold pl-3 drop-shadow-md text-xs whitespace-nowrap w-[100%]">
                        {{ $store.state.full_name }}
                    </div>
                    <div class="grow-0 pr-6">
                            <Dropdown/>
                    </div>
                    <div v-if="accountButton" class="shadow absolute mt-[80px]  bg-[#DCDDDC] rounded-sm w-full">
                        <div class="flex flex-col absolute bg-[#DCDDDC] w-full top-0">
                            <p class="text-sm hover:bg-[#CCAF12] px-5 py-3 text-md text-[#12760A] font-semibold border-b-[#bebebe] border" @click="$emit('changePass')">Change Password</p>
                            <button class="text-sm  hover:bg-[#CCAF12] px-5 py-3 text-left  text-md text-[#12760A] font-semibold" @click="$emit('logout')">Logout</button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { defineComponent } from 'vue';
import Avatar from '../icons/AvatarIcon.vue'
import Dropdown from '../icons/DropDownIcon.vue'
// import Message from '../icons/MessageIcon.vue'
import Notification from '../icons/NotificationIcon.vue'

export default defineComponent({
    components:{
        Avatar,
        Dropdown,
        // Message,
        Notification
    },
    data(){
        return{
            accountDrop: false,
            notification: false
        }
    },
    props:{
        notificationButton:{
            type: Boolean,
            default: false
        },
        accountButton:{
            type: Boolean,
            default: false
        },

    }
})


</script>

<style scoped>
.shadow{
    box-shadow: rgba(6, 24, 44, 0.048) 0px 0px 0px 2px, rgba(6, 24, 44, 0.493) 0px 4px 6px -1px, rgba(255, 255, 255, 0.24) 0px 1px 0px inset;
 }
</style>